export const smoothScroll = () => {
    const scrollToAnchor = (targetElement) => {
        const header = document.querySelector('nav');
        const headerOffset = header ? header.offsetHeight : 0;

        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offset = elementPosition - headerOffset;

        requestAnimationFrame(() => {
            document.querySelector('body').scrollBy({
                left: 0,
                top: offset,
                behavior: 'smooth'
            });
            document.querySelector('html').scrollTo({
                left: 0,
                top: offset,
                behavior: 'smooth'
            });
        });
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (!targetElement) return;

            const currentUrl = new URL(window.location.href);
            currentUrl.hash = targetId;
            history.pushState(null, null, currentUrl.href);

            scrollToAnchor(targetElement);
        });
    });

    window.addEventListener('DOMContentLoaded', () => {
        if (window.location.hash) {
            const hash = window.location.hash;

            const targetElement = document.querySelector(hash);

            if (!targetElement) return;

            scrollToAnchor(targetElement);
        }
    });

}
